import {ScheduleCalendarType} from '../types';
import {getPeriod} from './getPeriod';
import {isDateInRange} from './isDateInRange';

/**
 * Returns true if the provided date is in the same period as
 * the periode date with the given calendar type
 * @param date
 * @param periodDate
 * @param calendarType
 */
export const isDateInPeriod = (
  date: string | Date,
  periodDate: Date | string,
  calendarType: ScheduleCalendarType,
): boolean => {
  const {from, to} = getPeriod(periodDate, calendarType);
  return isDateInRange(date, from, to);
};
